<template>
  <section class="section section--alt">
    <div class="container">
      <h2 class="section-title">{{ t("stats.title") }}</h2>
      <p class="section-lead">{{ t("stats.lead") }}</p>
      <div class="stats">
        <article v-for="index in 4" :key="index" class="stat">
          <strong>{{ t(`stats.items.${index - 1}.value`) }}</strong>
          <span>{{ t(`stats.items.${index - 1}.label`) }}</span>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "StatsSection",
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>
